import { Box, Space, Stack, Text } from '@mantine/core';
import { FC, memo } from 'react';
import { Button } from 'src/components/Button';
import { Modal } from 'src/components/Modal';
import { useDeleteCampaign } from './use-delete-campaign';

export const DeleteCampaignModal: FC = memo(() => {
  const { handleConfirm, handleClose, isPending, open } = useDeleteCampaign();

  return (
    <Modal
      opened={open}
      onClose={handleClose}
      centered
      size="lg"
      closeOnClickOutside={!isPending}
      closeOnEscape={!isPending}
      withCloseButton={!isPending}
    >
      <Stack gap="md" align="center">
        <Text size="md" ta="center">
          Are you sure you want to delete this campaign?
        </Text>

        <Text size="sm" ta="center">
          This action cannot be undone and will permanently remove the campaign.
        </Text>

        <Space h="lg" />

        <Box display="flex" style={{ gap: '36px' }}>
          <Button
            variant="outline"
            round
            size="md"
            onClick={handleClose}
            disabled={isPending}
          >
            Cancel
          </Button>
          <Button
            variant="danger"
            round
            size="md"
            onClick={handleConfirm}
            loading={isPending}
            disabled={isPending}
          >
            Delete
          </Button>
        </Box>
      </Stack>
    </Modal>
  );
});
